import DefaultAvatar from 'components/common/DefaultAvatar';
import React from 'react';

import TransactionActivityTab from '../TransactionActivityTab';
import TransactionDetailTab from '../TransactionDetailTab';
import TransactionMessageTab from '../TransactionMessageTab';
import TransactionScannedDocsTab from '../TransactionScannedDocsTab';

export const getTransactionTabs = (messageCount = 0, scannedFilesCount = 0, isClient = true) => {
  const messageTab = isClient
    ? [
        {
          title: (
            <div className='flex items-center'>
              <div className='mr-2'>Messages</div>
              {messageCount !== 0 && messageCount && <DefaultAvatar bgColor='red'>{messageCount}</DefaultAvatar>}
            </div>
          ),
          component: TransactionMessageTab,
        },
      ]
    : [];
  const docsTab = isClient
    ? [
        {
          title: (
            <div className='flex items-center'>
              <div className='mr-2'>Returned Documents</div>
              {scannedFilesCount !== 0 && scannedFilesCount && (
                <DefaultAvatar bgColor='red'>{scannedFilesCount}</DefaultAvatar>
              )}
            </div>
          ),
          component: TransactionScannedDocsTab,
        },
      ]
    : [];
  const activitiesTab = isClient ? [{ title: 'Activity Log', component: TransactionActivityTab }] : [];
  return [{ title: 'Details', component: TransactionDetailTab }, ...messageTab, ...activitiesTab, ...docsTab];
};
